/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Legal_Travel_Landing_TaglineInputs */

const en_service_legal_travel_landing_tagline = /** @type {(inputs: Service_Legal_Travel_Landing_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legal Assistance While Travelling`)
};

const fr_service_legal_travel_landing_tagline = /** @type {(inputs: Service_Legal_Travel_Landing_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assistance juridique en voyage`)
};

/**
* | output |
* | --- |
* | "Legal Assistance While Travelling" |
*
* @param {Service_Legal_Travel_Landing_TaglineInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const service_legal_travel_landing_tagline = /** @type {((inputs?: Service_Legal_Travel_Landing_TaglineInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Legal_Travel_Landing_TaglineInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_service_legal_travel_landing_tagline(inputs)
	return fr_service_legal_travel_landing_tagline(inputs)
});